<template>
  <div>
      <div class="notification-wrapper">
        <div
          class="notification-white-bar"
          :class="'right-0'"
        ></div>
        
        <div 
          v-for="message in this.notifications"
          :key="message.id"
          class="main-notification unread"
          @click="isReadNotification(message)"
          :class="{ read: message.read }"
        >
          <div class="notification-title">
            <img  src="@/assets/images/happy.png" alt />
            <!-- <img v-else src="@/assets/images/sceptic.png" alt /> -->
            <h6>&#8226; {{message.dateIssued + " " +  message.dateIssued | fromNow }}</h6>
          </div>
          <div class="notification-content">
            <h6>{{ message.title }}</h6>
            <p>
              {{message.message}}
              <!-- <read-more
                class="offer-description"
                :moreStr="$t('readMore')"
                :text="message.message"
                link="#"
                :lessStr="$t('readLess')"
                :max-chars="100"
              ></read-more> -->
            </p>
          </div>
          <!-- <div class="notification-footer">
            <p>
              <a class="status-background notification-delete-button ">{{ $t("deleteNotification") }}</a>
            </p>
          </div> -->
        </div>
      </div>
  </div>
</template>


<script>
import moment from "moment";
import httpServiceCustomer from "@/http/http-customer.js";
import Cookies from "js-cookie";

export default {
  name: "NotificationBox",
  props: {
    notifications: Array
  },
  data() {
    return {
    };
  },
  filters: {
    fromNow(date) {
			return moment(date, "YYYY-MM-DDThh:mm:ss").fromNow();
		}
  },
  methods: {
    isReadNotification(message) {
      message.read = true;
      httpServiceCustomer.customerService
        .markMessageAsRead(message, Cookies.get("token"))
        .catch(function(error) {
          // handle error
        });
    },
  },
  mounted() {}
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
